import React from "react";
import { Route, Routes } from "react-router-dom";

import { RootLayout } from "../Components/RoutLayout";
import Home from "../Components/Home";
import AboutUs from "../Components/AboutUs";
import ContactUs from "../Components/ContactUs";
import { BlogSingle } from "../Components/BlogSingle";
import CancellationPolicy from "../Components/CancellationPolicy";
import TermsConditions from "../Components/TermsConditions";
import PrivacyPolicy from "../Components/PrivacyPolicy";

export default function Router() {
  return (
    <Routes>
      <Route path="" element={<RootLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/cancellation-and-refund-policy" element={<CancellationPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* <Route path="/blog/:id" element={<BlogSingle />} /> */}
      </Route>
    </Routes>
  );
}
